<div class="form-field-wrapper">
  @if(!viewMode) {
  <label class="form-field-label" [ngClass]="{ 'required': isRequired }">
    <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
    {{ label }}
  </label>
  @if(translated) {
    <input
    id="app-input-form-field"
    class="form-field"
    [type]="type"
    [placeholder]="placeholder | translate"
    [ngClass]="{ 'input-required': errorText, 'form-field__with-translation': translatable && formControl.value }"
    [value]="translated"
    disabled
  />
  } @else {
    <input
    id="app-input-form-field"
    class="form-field"
    [type]="type"
    [formControl]="formControl"
    [placeholder]="placeholder | translate"
    [ngClass]="{ 'input-required': errorText, 'form-field__with-translation': translatable && formControl.value }"
    (input)="onChangeValue($event)"
  />
  }
  @if(translatable && formControl.value) {
    <app-translate-field-value [value]="formControl.value" (onTranslate)="translate($event)"></app-translate-field-value>
  }
  } @else {
  <div class="d-flex mb-2 responsive-field" [ngClass]="{ 'label-top-position': isLabelTopPosition }">
    <label class="form-field-label form-field-label__overview"
      [ngClass]="{ 'required': isRequired, 'text-secondary' : formControl.status === 'DISABLED' }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
      @if(!inlineEditMode) {
        @if(translated) {
          <div
            class="field-value field-value-inline"
            [ngClass]="{'text-secondary field-value-inline__disabled' : formControl.status === 'DISABLED' }"
          >
            {{ translated }}
          </div>
        } @else {
          <div
            class="field-value field-value-inline"
            (click)="formControl.status !== 'DISABLED' ? inlineEditMode = true : false"
            [ngClass]="{'text-secondary field-value-inline__disabled' : formControl.status === 'DISABLED' }"
            attr.title="{{ formControl.status !== 'DISABLED' ? ('label.click_to_edit' | translate) : null }}"
          >
            @if(formControl.value) {
              <span class="field-has-value">{{ formControl.value }}</span>
              @if (errorText) {
                <span class="form-field-info form-field-info-inline required-label free-text"> {{ errorText | translate }}</span>
              }
            } @else {
              <span class="no-data-inline-form">/</span>
              @if (errorText) {
                <span class="form-field-info form-field-info-inline required-label free-text"> {{ errorText | translate }}</span>
              }
            }
          </div>
        }

      } @else {
        <div class="w-100">
          @if(translated) {
            <input
              class="form-field form-field-inline"
              [ngClass]="{'form-field__with-translation': translatable && formControl.value}"
              [type]="type"
              [placeholder]="placeholder | translate"
              [value]="translated"
              disabled
            />
          } @else {
            <input
            class="form-field form-field-inline"
            [ngClass]="{'form-field__with-translation': translatable && formControl.value}"
            [type]="type"
            [formControl]="formControl"
            [placeholder]="placeholder | translate"
            (input)="onChangeValue($event)"
          />
          }
          @if (errorText) {
            <span class="form-field-info form-field-info-inline required-label"> {{ errorText | translate }}</span>
            }
        </div>
      }
  </div>
  @if(translatable && formControl.value) {
    <app-translate-field-value [value]="formControl.value" (onTranslate)="translate($event)"></app-translate-field-value>
 }
  }
  @if (errorText && !viewMode) {
  <span class="form-field-info required-label"> {{ errorText | translate }}</span>
  }
  @if (infoText && !errorText && !viewMode) {
  <span class="form-field-info">{{ infoText }}</span>
  }
</div>
